import { defineMessages } from 'react-intl';

export default defineMessages({
  leadText: {
    id: 'multiQuotesBlock.leadText',
    defaultMessage: 'Your quote for zip code',
  },
  adjustLimitText: {
    id: 'multiQuotesBlock.adjustLimitText',
    defaultMessage: 'Your coverage amount',
  },
  ctaButtonText: {
    id: 'multiQuotesBlock.ctaButtonText',
    defaultMessage: 'Get Protected',
  },
  pdsLinkText: {
    id: 'multiQuotesBlock.pdsLinkText',
    defaultMessage: 'View Policy Wording',
  },
});
